<div class="warehouse-page">
  <ui-page-header [title]="'warehouse.warehouses' | translate" [lucideIcon]="'Package'">
    <!-- <ui-button 
      type="primary" 
      [label]="('warehouse.add_new' | translate)"
      icon="plus-cc"
      iconSize="large"
      iconPosition="start"
      (click)="addWarehouse()">
    </ui-button> -->
  </ui-page-header>
  <div class="warehouse-content">
    <div class="warehouse-card" *ngFor="let warehouse of warehouses">
      <div class="card-header">
        <div class="header-left">
          <div class="title">
            {{ warehouse.name }}
          </div>
          <span *ngIf="warehouse.is_primary" class="status-badge">{{ "warehouse.primary" | translate }}</span>
        </div>
        <button class="action-button" [matMenuTriggerFor]="menu">
          <app-svg-icon svgIcon="more"></app-svg-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button mat-menu-item class="menu-item edit-btn" (click)="editWarehouse(warehouse)">
            <span class="icon">
              <app-svg-icon svgIcon="edit_icon"></app-svg-icon>
            </span>
            <span class="label">{{ "common.edit" | translate }}</span>
          </button>
          <button
            *ngIf="false"
            mat-menu-item
            class="menu-item delete-btn"
            (click)="deleteWarehouse(warehouse)"
          >
            <span class="icon">
              <app-svg-icon svgIcon="trash-cc"></app-svg-icon>
            </span>
            <span class="label">{{ "common.delete" | translate }}</span>
          </button>
        </mat-menu>
      </div>
      <div class="card-body">
        <div class="card-row">
          <div class="col">
            <div class="label">{{ "warehouse.country" | translate }}</div>
            <div class="value">{{ warehouse.country?.name }}</div>
          </div>
          <div class="col">
            <div class="label">{{ "warehouse.internal_id" | translate }}</div>
            <div class="value">{{ warehouse.external_id || ("warehouse.n_a" | translate) }}</div>
          </div>
        </div>
        <div class="card-row">
          <div class="col">
            <div class="label">{{ "warehouse.address" | translate }}</div>
            <div class="value">{{ warehouse.address?.name || ("warehouse.n_a" | translate) }}</div>
          </div>
          <div class="col">
            <div class="label">{{ "warehouse.source" | translate }}</div>
            <div class="value tooltip-container">
              {{ warehouse.source ? ("warehouse.erp_integration" | translate) : ("warehouse.n_a" | translate) }}
              <span *ngIf="warehouse.read_only" class="tag-badge">{{ "warehouse.read_only" | translate }}</span>
              <div class="tooltip">
                {{ 'warehouse.erp_integration_tooltip' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="warehouse-cards-skeleton" *ngIf="isLoading$ | async">
      <div class="warehouse-card skeleton" *ngFor="let item of skeletons">
        <div class="card-header">
          <div class="header-left">
            <div class="skeleton-box title-skeleton title"></div>
            <div class="skeleton-box badge-skeleton status-badge"></div>
          </div>
          <div class="skeleton-box icon-skeleton action-button"></div>
        </div>
        <div class="card-body">
          <div class="card-row">
            <div class="col">
              <div class="label">
                <div class="skeleton-box label-skeleton"></div>
              </div>
              <div class="value">
                <div class="skeleton-box value-skeleton"></div>
              </div>
            </div>
            <div class="col">
              <div class="label">
                <div class="skeleton-box label-skeleton"></div>
              </div>
              <div class="value">
                <div class="skeleton-box value-skeleton"></div>
              </div>
            </div>
          </div>
          <div class="card-row">
            <div class="col">
              <div class="label">
                <div class="skeleton-box label-skeleton"></div>
              </div>
              <div class="value">
                <div class="skeleton-box value-skeleton"></div>
              </div>
            </div>
            <div class="col">
              <div class="label">
                <div class="skeleton-box label-skeleton"></div>
              </div>
              <div class="value">
                <div class="skeleton-box value-skeleton"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="load-more" *ngIf="hasMore" (click)="loadMore()" class="show-more">
      <span> Show More ({{ warehouses.length + "/" + metadata?.count }}) </span>
    </div>
  </div>
</div>
